import { createBrowserRouter, createRoutesFromElements, Route } from 'react-router-dom';
import React from 'react';

import { App } from 'app/app';
import { NavigationService } from 'app/services/navigation-service';
import { AuthCallbackPage } from 'app/pages/auth';
import { LogoutPage } from 'app/pages/logout';
import { GenericErrorPage } from 'app/pages/generic-error/generic-error-page';
import { CannotOrderNotAvailable } from 'app/pages/order/error/cannot-order-not-available';
import { SessionExpiredPage } from 'app/pages/auth/error';
import { AuthenticatedRoute } from 'app/components/authenticated-route';
import { CannotOrderProductNotAvailablePage } from 'app/pages/order/error/cannot-order-product-not-available-page';
import { Order } from 'app/pages/order';
import { config } from 'app/config/config';
import { CannotOrderNoActiveBroadbandPage } from 'app/pages/order/error/cannot-order-no-active-broadband-page';
import { NoServiceLocationPage } from 'app/pages/order/error/no-service-location-page';
import { CannotOrderMultipleBroadbandOfferPage } from 'app/pages/order/error/cannot-order-multiple-broadband-offer-page';
import { CannotOrderInflightOrderPage } from 'app/pages/order/error/cannot-order-inflight-order-page';
import { CannotOrderMorePage } from 'app/pages/order/error/cannot-order-more-page';
import { CannotOrderRestrictedPurchasePage } from 'app/pages/order/error/cannot-order-restricted-purchase-page';

if (config.ENV === 'development' && !window.location.pathname.includes(config.BASE_PATH)) {
    window.history.replaceState('', '', config.BASE_PATH);
}

export const router = createBrowserRouter(
    createRoutesFromElements(
        <Route element={<App />} errorElement={<GenericErrorPage />}>
            <Route path={NavigationService.AUTH_CALLBACK} element={<AuthCallbackPage />} />
            <Route path={NavigationService.LOGOUT} element={<LogoutPage />} />
            <Route path={NavigationService.ERROR} element={<GenericErrorPage />} />
            <Route path={NavigationService.ERROR_NOT_AVAILABLE} element={<CannotOrderNotAvailable />} />
            <Route path={NavigationService.ERROR_SESSION_EXPIRED} element={<SessionExpiredPage />} />
            <Route element={<AuthenticatedRoute />}>
                <Route
                    path={NavigationService.PRODUCT_NOT_AVAILABLE}
                    element={<CannotOrderProductNotAvailablePage />}
                />
                <Route
                    path={NavigationService.ERROR_NO_ACTIVE_BROADBAND}
                    element={<CannotOrderNoActiveBroadbandPage />}
                />
                <Route path={NavigationService.ERROR_NO_SERVICE_LOCATION} element={<NoServiceLocationPage />} />
                <Route
                    path={NavigationService.ERROR_MULTIPLE_BROADBAND_OFFERS}
                    element={<CannotOrderMultipleBroadbandOfferPage />}
                />
                <Route path={NavigationService.ERROR_HAS_INFLIGHT_ORDER} element={<CannotOrderInflightOrderPage />} />
                <Route path={NavigationService.ERROR_CANNOT_ORDER_MORE} element={<CannotOrderMorePage />} />
                <Route
                    path={NavigationService.ERROR_RESTRICTED_PURCHASE}
                    element={<CannotOrderRestrictedPurchasePage />}
                />
                <Route path="/*" element={<Order />} />
            </Route>
        </Route>,
    ),
    {
        basename: config.BASE_PATH,
    },
);
